const Demonstration = {
  namespaced: true,

  state() {
    return {
      uuid: null,
      name: null,
      impersonation_type: '[en] ceo ransomware',
      start_at: null,
      end_at: null,
      co_branding_logo: null,
    };
  },

  actions: {
    load({ commit }, uuid) {
      return axios.get(`/demonstrations/${uuid}`)
        .then((response) => {
          commit('setState', { data: response.data });
          return response;
        });
    },

    save({ commit, getters, state }) {
      const method = getters.exists ? 'put' : 'post';

      return axios[method](getters.path, state)
        .then((response) => {
          commit('setState', { data: response.data });
          return response;
        });
    },

    setName({ commit }, value) {
      commit('setProperty', {
        property: 'name',
        value,
      });
    },

    setCoBrandingLogo({ commit }, value) {
      commit('setProperty', {
        property: 'co_branding_logo',
        value,
      });
    },

    setImpersonationType({ commit }, value) {
      commit('setProperty', {
        property: 'impersonation_type',
        value,
      });
    },

    setStartAt({ commit }, value) {
      commit('setProperty', {
        property: 'start_at',
        value,
      });
    },

    setEndAt({ commit }, value) {
      commit('setProperty', {
        property: 'end_at',
        value,
      });
    },

    setUuid({ commit }, value) {
      commit('setProperty', {
        property: 'uuid',
        value,
      });
    },

    clear({ commit }) {
      commit('clear');
    },
  },

  mutations: {
    setProperty(state, { property, value }) {
      state[property] = value;
    },

    setState(state, { data }) {
      for (const property in data) {
        if (Object.prototype.hasOwnProperty.call(state, property)) {
          state[property] = data[property];
        }
      }
    },

    clear(state) {
      for (const property in state) {
        state[property] = null;
      }
      state.impersonation_type = '[en] ceo ransomware';
    },
  },

  getters: {
    exists(state) {
      return state.uuid !== null;
    },

    path(state) {
      const path = '/demonstrations/';

      return state.uuid ? path + state.uuid : path;
    },
  },
};

export default Demonstration;
